export const CLIENT_COLUMNS = {

  Triserv: [
    "sr_no", "assigned_to", "date_column", "priority", "file_number", "address", "in_time", "assign_time", "out_time", "tat", "reviewer_tat", "sla_status", "lender_name", "product_code", "appraiser_name", "loan_type",
    "lower_than_contract", "crosscheck_results", "pp", "market_value", "ten_percent", "notes_message", "reviewer_name",
    "qc_by", "feedback", "training", "training_findings", "auditor_findings", "feedback2", "day", "substatus", "status", "production_log",
    "escalations", "doubts", "advisor_note", "revisions", "shift"
  ],

  Dashboard: [
    "sr_no", "assigned_to", "date_column", "priority", "file_number", "address", "in_time", "assign_time", "out_time", "tat", "reviewer_tat", "sla_status", "lender_name"
  ]
};

export const INITIAL_STATE = {
  sr_no: "", assigned_to: "", date_column: "", priority: "", file_number: "", address: "",
  in_time: "", assign_time: "", out_time: "", tat: "", reviewer_tat: "", sla_status: "",
  lender_name: "", product_code: "", appraiser_name: "", loan_type: "", lower_than_contract: "",
  crosscheck_results: "", pp: "", market_value: "", ten_percent: "",
  notes_message: "", reviewer_name: "", qc_by: "", feedback: "", training: "", training_findings: "",
  auditor_findings: "", feedback2: "", day: "", substatus: "", status: "New", production_log: "",
  escalations: "", doubts: "", advisor_note: "", revisions: "", shift: "",
};

export const DROPDOWN_FIELDS = {
  assigned_to: [],
  priority: ["VIP", "Rush", "Due date", "Past due date", "Late"],
  product_code: [
    "1007", "1004", "1025", "1073", "2000", "55", "2006", "2055", "2075", "2090", "2095",
    "1004 + STR", "1004 Desktop", "1004 FHA", "1004 FHA / 216 / 1007", "1004 Hybrid",
    "1004 Jumbo", "1004 USDA", "1004 / 216/1007", "1004 + 1007",
    "1004C", "1004C FHA", "1004C USDA",
    "1004D", "1004D Recert of Value", "1004D Recert of Value/Update",
    "1004D Re-Inspect", "1004D Re-Inspect FHA",
    "1025 FHA", "1025 FHA / 216", "1025/216",
    "1073 - ARV/AS-IS", "1073+STR", "1073 FHA", "1073 / 1007", "1073 / 216 / 1007",
    "2000 Field Review", "2006 Desk Review",
    "2055 / 1007", "DAIR", "DAIR INT", "Do Not Review",
    "eVolve Appraisal - Drive-by", "eVolve Appraisal - No Inspection",
    "FHA Conversion", "General Purpose Appraisal", "Land Appraisal",
    "MH Appraisal", "ROV", "Tenants In Common", "UPD",
    "1075", "1025 - ARV/AS-IS", "1025 ARV/AS-IS/216", "ValPRAZE Interior/Exterior"
  ],
  loan_type: ['Conventional', 'FHA', 'USDA', 'VA', 'Jumbo'],
  lower_than_contract: ["Yes", "No"],
  crosscheck_results: ["Yes", "No"],
  production_log: ["Yes", "No"],
  status: ["New", "Rejected", "Completed", "Lender Revision", "Working", "Wrong Report", "Do Not Review", "Complete by Client"],
  substatus: [
    "Working", "Completed", "Rejected", "Accepted", "Escalated/Completed",
    "Escalated/Rejected", "Rejected /Emailed", "Wrong Report", "Do Not Review", "Completed /Emailed",
    "Need to Proceed", "Rejected /Revieiwed", "Completed /Revieiwed", "Complete by Client"
  ]
};

// ============================================================================
// ✅ CENTRALLY CONTROLLED CLIENT & DEPARTMENT TAT TARGETS (Values in Hours)
// ============================================================================
export const CLIENT_TAT_TARGETS = {
  // Global Operational Shift Defaults (Fallback if specific client isn't listed below)
  //"default_qc": 2,        // Standard QC processing cutoff limit
  // "default_revised": 1,   // Standard Revision / Report Writing cutoff limit

  // Individual Client Targets (Change these hour values directly whenever rules shift)
  "proval net": { qc: 2, revised: 1 },
  "mma": { qc: 2, revised: 1 },
  "a1 amc": { qc: 2, revised: 1 },
  "aag": { qc: 2, revised: 1 },
  "aams": { qc: 2, revised: 1 },
  "all pro amc": { qc: 2, revised: 1 },
  "appraisal partner": { qc: 4, revised: 1 },
  "appraisers review": { qc: 2, revised: 1 },
  "ascribe vl": {
    priority_qc: 2,     // VIP, Due date, Past due date, Rush get 2 hours
    normal_qc: 4,       // Standard normal files get 4 hours
    revised: 1          // Revisions stay at 1 hour
  },
  "core valuation": { qc: 2, revised: 1 },
  "ea - appraisals": { qc: 2, revised: 1 },
  "eppraisal": { qc: 4, revised: 1 },
  "exactus": { qc: 2, revised: 1 },
  "financial dimensions": { qc: 4, revised: 2 },
  "inspectify - hybrid": { qc: 2, revised: 1 },
  "lres - appraisals": { qc: 2, revised: 1 },
  "lvs": { qc: 4, revised: 0.1 },
  "nan": { qc: 2, revised: 1 },
  "property valuation network": { qc: 2, revised: 1 },
  "signature": { qc: 2, revised: 1 },
  "team matthew appraisals": { qc: 1, revised: 1 },
  "top notch appraisers": { qc: 1, revised: 1 },
  "valora amc": { qc: 2, revised: 1 },
  "valutrust solutions": { qc: 2, revised: 1 },
  "zap appraisal": { qc: 2, revised: 1 },
  "zap new": { qc: 2, revised: 1 }
};
